import { onViewAllMenuClicked } from 'owa-mail-moveto-control/lib/actions/internalActions';
import { getStore } from 'owa-mail-moveto-control/lib/store/store';
import { mutator } from 'satcheljs';

/**
 * Subscribes to onViewAllMenuClicked action and mutates moveToSharedFolderRootId
 */
mutator(onViewAllMenuClicked, actionMessage => {
    getStore().moveToSharedFolderRootId = actionMessage.rootFolderId;
});
